module.exports = __webpack_public_path__ + "images/handelszaken-fa30aa65196cee77ba3a2fa75572a85c.svg";


//////////////////
// WEBPACK FOOTER
// ./src/static/images/Logos_icons/handelszaken.svg
// module id = 759
// module chunks = 0